import Box from '@zenbusiness/zui/Box';
import Skeleton from '@zenbusiness/zui/Skeleton';

import * as Styled from './ProfileHeader.style';

function ProfileHeaderLoadingState() {
  return (
    <Styled.LoadingOuter data-testid="profile-header-loading-outer">
      <Styled.LoadingEntity data-testid="profile-header-loading-entity">
        <Styled.LoadingAvatarWrapper>
          <Skeleton role="img" width={60} height={100} />
        </Styled.LoadingAvatarWrapper>
        <Box>
          <Skeleton role="img" width={200} height={20} />
          <Skeleton role="img" width={100} height={20} />
        </Box>
      </Styled.LoadingEntity>
      <Styled.LoadingStatus data-testid="profile-header-loading-status">
        <Skeleton role="img" width={200} height={20} />
        <Skeleton role="img" width={200} height={20} />
        <Skeleton role="img" width={200} height={60} />
      </Styled.LoadingStatus>
    </Styled.LoadingOuter>
  );
}

export default ProfileHeaderLoadingState;
